module.exports = __webpack_public_path__ + "img/5.947a0cbe.jpg";